<img #img class="lazyload img-placeholder {{classes}}" src="data:image/gif;base64,R0lGODlhAQABAPAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
     [attr.data-src]="imageUrl"
     (error)="imageService.updateErroredImage($event)"
     aria-hidden="true"
     alt=""
    >
